import React from 'react';
import { css } from 'styled-components';

import parseQueryStrings from '@crehana/utils/dist/parseQueryStrings';
import MainMenu from '@crehana/web/dist/MainMenu/MainMenu';

import { MainFooter } from '@crehana/web';

import { useUITheme } from 'Jsx/ContextApis/UITheme';
import { MainMenuProviderWrapper as MainMenuProvider } from 'Jsx/CrehanaWeb/MainMenuWrapper';
import { InitialStateResult } from 'Jsx/Utils/getBaseInitialState';

import { SEARCH_LANDING_AMPLITUDE_PAGE_NAME } from './constants';

import SearchLanding from './main/SearchLanding';

export type ExtraState = {};

export type AppProps = {};

const App: React.FC<InitialStateResult<AppProps & ExtraState>> = ({
  countryPrefix,
}) => {
  const { isDark, theme } = useUITheme();
  const queryStrings = parseQueryStrings(
    typeof window !== 'undefined' ? window.location.search : '',
  );
  const initialSearchTerm =
    typeof queryStrings?.q === 'string'
      ? decodeURIComponent(queryStrings.q)
      : '';

  return (
    <MainMenuProvider
      position="sticky"
      theme={theme}
      layoutConfig={{ hideNightSwitch: false }}
      initialSearchTerm={initialSearchTerm}
      amplitudePageName={SEARCH_LANDING_AMPLITUDE_PAGE_NAME}
    >
      <div
        className={`min-h-screen ${
          isDark ? 'bg-base-dark text-white' : 'bg-white text-base-main'
        }`}
        // eslint-disable-next-line react/no-unknown-property
        css={css`
          transition: ${props =>
            props.theme.transition(['background-color', 'color'])};
        `}
      >
        <MainMenu />
        <SearchLanding
          countryPrefix={countryPrefix}
          searchTerm={initialSearchTerm}
        />
        <MainFooter isDark={isDark} />
      </div>
    </MainMenuProvider>
  );
};

export default App;
